// extracted by mini-css-extract-plugin
export default {"form":"CafeForm_form__nn5Jr","button":"CafeForm_button__mEzod","formGroup":"CafeForm_formGroup__eaa43","editor":"CafeForm_editor__+f0P1"};